// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.zjBW0Qf64sFif0Ol2SZQ {
    margin-top: 32px;

    && {
        padding: 40px;
    }
}

.nIlU2UGlDR4twZ_Xry_8 {
    display: flex;
    flex-direction: column;
    width: 100%;
    align-items: center;
    margin-bottom: 10px;
}

.HPnXFeAljhTrCNuddwqk {
    margin-top: 32px !important;
    margin-bottom: 32px !important;
}
`, "",{"version":3,"sources":["webpack://./UiNew/components/Telehealth/InformationCard/InformationCard.module.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;;IAEhB;QACI,aAAa;IACjB;AACJ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,mBAAmB;IACnB,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;IAC3B,8BAA8B;AAClC","sourcesContent":[".informationCard {\n    margin-top: 32px;\n\n    && {\n        padding: 40px;\n    }\n}\n\n.chipContainer {\n    display: flex;\n    flex-direction: column;\n    width: 100%;\n    align-items: center;\n    margin-bottom: 10px;\n}\n\n.divider {\n    margin-top: 32px !important;\n    margin-bottom: 32px !important;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"informationCard": `zjBW0Qf64sFif0Ol2SZQ`,
	"chipContainer": `nIlU2UGlDR4twZ_Xry_8`,
	"divider": `HPnXFeAljhTrCNuddwqk`
};
export default ___CSS_LOADER_EXPORT___;
